//@ts-nocheck
import React from 'react';
import { Card } from './ui/Card';

const SuccessMetricCard = ({ title, description }) => (
  <Card>
    <h3 className="text-lg font-semibold mb-2">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </Card>
);

export const HowWeMeasureSuccess: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
        <SuccessMetricCard 
          title="Accessibility Audits"
          description="Regular assessments to ensure compliance with global accessibility standards."
        />
        <SuccessMetricCard 
          title="User Feedback"
          description="Engaging with diverse communities to improve and evolve continuously."
        />
        <SuccessMetricCard 
          title="Impact Metrics"
          description="Tracking adoption rates among users with disabilities, non-native speakers, and underserved groups."
        />
      </div>
    </div>
  );
};

